// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import { CypressFields } from '../../utils/Cypress';
import { useCart } from '../../providers/Cart.provider';
import CartDropdown from '../CartDropdown';
import * as S from './CartIcon.styled';

const CartIcon = () => {
  const {
    cart: { items },
    isDrawerOpen,
    openDrawer,
    closeDrawer,
  } = useCart();

  const itemCount = items.reduce((count, { quantity }) => count + quantity, 0);

  return (
    <>
      <S.CartIcon
        as="button"
        data-cy={CypressFields.CartIcon}
        data-cart-toggle
        onClick={isDrawerOpen ? closeDrawer : openDrawer}
        aria-label={`Shopping cart with ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`}
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M6 7h12l1 14H5L6 7z" />
          <path d="M9 10V6a3 3 0 0 1 6 0v4" />
        </svg>
        {itemCount > 0 && <S.ItemsCount data-cy={CypressFields.CartItemCount}>{itemCount}</S.ItemsCount>}
      </S.CartIcon>
      <CartDropdown productList={items} isOpen={isDrawerOpen} onClose={closeDrawer} />
    </>
  );
};

export default CartIcon;
